
const ROADS_NPM_KPI_INIT = {
    infrastructure: {
        heavyPreiodicMainReq: {
            req_rehab_open_roads: "",
            req_rehab_tunnels: "",
            req_rehab_bridges: "",
            req_hp_maint_open_roads: "",
            req_hp_maint_tunnels: "",
            req_hp_maint_bridges: ""
        },
        upgratingReq: {
            req_upgrade_open_roads: "",
            req_upgrade_tunnels: "",
            req_upgrade_bridges: ""
        },
        climateChangeResil: {
            ch_flood_inci: "",
            ch_closure_adv_weather_cond : "",
            ch_embank_fail: ""
        }
    },
    operations: {
        HVGTTI: "",
        PCsTTI: "",
        delaysBasedTTIHVG: "",
        delaysBasedTTIPCs: "",
        delaysCost: "",
        ave_travel_time_pcs: "",
        ave_travel_time_hvgs: ""
    },
    safety: {
        total_traffic_ser_inj: "",
        fata_traffic_crash: "",
        ser_inj: ""
    },
    maintenance: {
        maint_cost_total: "",
        maint_cost_open_roads: "",
        maint_cost_tunnels: "",
        maint_cost_bridges: "",
        hp_maint_cost: "",
        emer_maint_cost: "",
        winter_maint_cost: "",
        routine_maint_cost: ""
    },
    environmentalImpact: {
        globalWarmingPotential: "",
        noise: ""
    }
}

const ROADS_SAFETY_KPI_INIT = {
    safety: {
        total_traffic_crashes_serious_inj_pop: "", 
        total_traffic_crashes_serious_inj_vehi: "",
        seriously_injured: "",
        fatalities: "",
        causa_acc: {
            cause_acc_alcohol_per: "",
            cause_acc_speed_per: "",
            cause_acc_infrastructure_per: "",
            cause_acc_electronic_dev_per: "",
            cause_acc_veh_corres_stadards_per: "",
        },
        cause_accidentsPcg: {
            cause_acc_alcohol_per: "",
            cause_acc_speed_per: "",
            cause_acc_infrastructure_per: "",
            cause_acc_electronic_dev_per: "",
            cause_acc_veh_corres_stadards_per: "",
        }
    }
}

const RAILWAYS_NPM_KPI_INIT = {
    infrastructure: {
        heavyPreiodicMainReq: {
            req_heavy_maint: "",
            req_rehab: ""
        },
        upgradingRequirements: {
            req_upgrade_inc_cap: "",
            req_upgrade_add_line: ""
        },
        climateChangeResil: {
            ch_flood_inci: "",
            ch_closure_adv_weather_cond : "",
            ch_embank_fail: ""
        }
    },
    operations: {
        capacity_used: "",
        ave_travel_time_pass: "",
        ave_travel_time_freight: ""
    },
    safety: {
        num_signi_accidents_change: "",
        ser_accident_fatal: "",
        ser_accident_fatal_change: "",
        ser_accident_ser_inj: "",
        signi_inj_accident_levelcross: "",
        signi_inj_accident_levelcross_change: "",
        ser_accident_levelcross: "",
        levelCrossingsFatalities: ""
    },
    maintenance: {
        maint_cost_total_kmpy: "",
        maint_cost_infra: "",
        maint_cost_sign_telecom: "",
        maint_cost_elect: ""
    },
    environmentalImpact: {
        globalWarmingPotential: "", 
        noise: ""
    }
}

const FREIGHT_TERMINAL_NPM_KPI_INIT = {
    infrastructure: {
        condition: {
            veryGood: "",
            good: "",
            medium: "",
            poor: "",
            veryPoor: ""
        },
        rail_conn: "",
        road_conn: "",
        iww_conn: "",
        sea_conn: "",
        air_conn: "",
        req_upgrade_inc_cap: "",
        climateChangeResil: {
            ch_flood_inci: "",
            ch_closure_adv_weather_cond : "",
            ch_embank_fail: ""
        }
    },
    TEN_TCompliance: {
        inter_modality: "",
        train_length_740m: "",
        electrified_access: "",
        open_availability: ""
    },
    operations: {
        storage_capacity_used: "",
        trsnshipment_capacity_used: ""
    },
    maintenance: {
        maint_cost_total_py: "",
        emergency_cost_py: "",
        routine_cost_py: ""
    },
    environmentalImpact: {
        co2_ems: "",
        nox_ems: "",
        so2_ems: "",
        nmhc_ems: "",
        ppm: ""
    }
}

const IWW_NPM_KPI_INIT = {
    infrastructure: {
        locks: "",
        lock_type: {
            double_lock: "",
            single_lock: ""
        },
        its: "",
        heavyPreiodicMainReq: {
            req_heavy_maint: "", 
            req_rehab: "" 
        },
        req_upgrade_inc_cap: "",
        climateChangeResil: {
            ch_flood_inci: "",
            ch_closure_adv_weather_cond : "",
            ch_embank_fail: ""
        }
    },
    maintenance: {
        maint_cost_total_py: "",
        maint_cost_landslide_py: "",
        maint_cost_riverslide_py: ""
    },
    environmentalImpact: {
        co2_ems: "",
        nox_ems: "",
        so2_ems: "",
        nmhc_ems: "",
        ppm: ""
    }
}

const IWW_PORTS_NPM_KPI_INIT = {
    infrastructure: {
        upgratingReq: {
            passenger_capacity: "",
            freight_capacity_tn_py: ""
        },
        climateChangeResil: {
            ch_flood_inci: "",
            ch_closure_adv_weather_cond : "",
            ch_embank_fail: ""
        }
    },
    maintenance: {
        maint_cost_total_py: "",
        maint_cost_landslide_py: "",
        maint_cost_riverslide_py: ""
    },
    environmentalImpact: {
        co2_ems: "",
        nox_ems: "",
        so2_ems: "",
        nmhc_ems: "",
        ppm: ""
    }
}

const SEAPORTS_NPM_KPI_INIT = {
    infrastructure: {
        upgratingReq: {
            passenger_capacity: "",
            freight_capacity_tn_py: ""
        },
        climateChangeResil: {
            ch_flood_inci: "",
            ch_closure_adv_weather_cond : ""
        }
    },
    maintenance: {
        maint_cost_total_py: "",
        maint_cost_landslide_py: "",
        maint_cost_maritime_py: ""
    },
    environmentalImpact: {
        co2_ems: "",
        nox_ems: "",
        so2_ems: "",
        nmhc_ems: "",
        ppm: ""
    }
}

const AIRPORTS_NPM_KPI_INIT = {
    infrastructure: {
        upgratingReq: {
            pass_capacity: "",
            runway_capacity_fph: ""
        },
        climateChangeResil: {
            ch_flood_inci: "",
            ch_closure_adv_weather_cond : ""
        }
    },
    operations: {
        pass_transit: "" // TODO: consultar si solo se muestra solo si se filtra por pais ya que el KPI es % de pasajeros por destino
    },
    maintenance: {
        maint_cost_total_py: "",
        maint_cost_pass_term_py: "",
        maint_cost_freight_term_py: "",
        maint_cost_runways_py: ""
    },
    environmentalImpact: {
        co2_ems: "",
        nox_ems: "",
        so2_ems: "",
        nmhc_ems: "",
        ppm: ""
    }
}

const BORDER_CROSSING_NPM_KPI_INIT = {
    infrastructure: {
        oneStopProce: {
            pcg_bcps: ""
        },
        stateOfPlay: {
            state_play_booth: "",
            state_play_data_system: "",
            state_play_phis_insp_faci: ""
        },
        eqms: "",
        other_electronic_is: "",
        upgratingReq: {
            req_upgrade_inc_capacity: "",
            req_upgrade_its: ""
        }
    },
    operations: {
        typeControls: {
            control_type_phytosanitary: "",
            control_type_veterinary: "",
            control_type_radiological: "",
            control_type_other: ""
        }
    }
}

const ROAD_IMP_PM_KPI_INIT = {
    performanceInd : {
        projectTimelineDeviation : {
            init_proj_comp_date: "",
            actual_proj_comp_date: ""
        },
        capex: "",
        opex: "",
        maintenance: "",
        ebitda: "",
        revenue: "", // actual_revenue/forecast_revenue
        traffic_dev: {
            total: "", // actual_total/forecast_total
            pass_cars: "", // actual_pass_cars/forecast_pass_cars
            busses: "", //actual_busses/forecast_busses
            hgv: "" // TODO: consultar el campo 
        }
    }
}

const ROAD_LIVE_PM_KPI_INIT = {
    projectTimeline : {
        tender_start_date: "", // tender_start_date_actual || tender_start_date_curr_est
        design_comp_date: "", // dessign_comp_date_actual || dessign_comp_date_curr_est
        proj_comp_date: "" // proj_comp_date_curr_est
    },
    project_tech_status: {
        pre_feasi_study: "", // calcular el promedio de los calores en YES
        feasi_study: "",
        concept_design: "",
        prelim_design: "",
        detail_design: "",
        environ_impact_assess: ""
    },
    socialInd: {
        si_ann_traff_dem_gro: "",
        si_modal_trans: "",
        si_ann_traff_acci_rate_red: ""
    },
    eco_indicators: {
        ei_eirr: "",
        ei_npv: "",
        ei_sdr: "",
        ei_proj_plan_des_cost: "",
        ei_proj_const_cost: "",
        ei_total_proj_cost: "",
    },
    financial_indicators: {
        fi_firr: "",
        fi_fnpv: "",
        fi_fdr: "",
        fi_wacc: "",
        fi_firts_year_prof: "",
        fi_dscr: "",
    }, 
    environmental_indicators: {
        eni_co2_ems: "",
        eni_nox_ems: "",
        eni_so2_ems: "",
        eni_nmhc_ems: "",
        eni_ppm: "",
        eni_noise_level: "",
        eni_cli_change_res: "",
        eni_prote_natua_aff: "",
    }
}

const RAILWAYS_IMP_PM_KPI_INIT = {
    performanceInd: {
        projectTimeDev : {
            proj_comp_date: "", // actual_proj_comp_date - init_proj_comp_date
            const_period: "", // actual_const_period / forecast_const_period
            capex: "", // actual_capex / forecast_capex
            opex: "", // actual_opex / forecast_opex
            maint_cost: "", // actual_maint_cost / forecast_maint_cost
            ebitda: "",
            revenue: "", // actual_revenue / forecast_revenue
            traffic_dev: {
                train_traffic: "", // actual_train_traffic / forecast_train_traffic
                pass_traffic: "",
                freight_tn: "" // actual_freight_tn / forecast_freight_tn
            }
        }
    }
}

const RAILWAYS_LIVE_PM_KPI_INIT = {
    project_timeline: {
        tender_start_date: "",
        design_comp_date: "", 
        proj_comp_date: "", 
    },
    project_tech_status: {
        pre_feasi_study: "",
        feasi_study: "",
        concept_design: "",
        prelim_design: "",
        detail_design: "",
        environ_impact_assess: ""
    },
    social_indicators: {
        si_ann_traff_dem_gro: "",
        si_modal_trans: "",
        si_ann_traff_acci_rate_red: ""
    },
    eco_indicators: {
        ei_eirr: "",
        ei_npv: "",
        ei_sdr: "",
        ei_proj_plan_des_cost: "",
        ei_proj_const_cost: "",
        ei_total_proj_cost: "",
    },
    financial_indicators: {
        fi_firr: "",
        fi_fnpv: "",
        fi_fdr: "",
        fi_wacc: "",
        fi_firts_year_prof: "",
        fi_dscr: "",
    }, 
    environmental_indicators: {
        eni_co2_ems: "",
        eni_nox_ems: "",
        eni_so2_ems: "",
        eni_nmhc_ems: "",
        eni_ppm: "",
        eni_noise_level: "",
        eni_cli_change_res: "",
        eni_prote_natua_aff: "",
    }
}

const FREIGHT_TERMINAL_IMP_PM_KPI_INIT = {
    project_type: {
        infrastructure: '',
        reconstruction: '',
        maintenances: '',
        horizontal: ''
    },
    TEN_TCompliance: {
        inter_modality: {
            bef_inter_modality: '',
            aft_inter_modality: ''
        },
        train_length_740m: {
            bef_train_length_740m: '',
            aft_train_length_740m: ''
        },
        electrification: {
            bef_electrification: '',
            aft_electrification: ''
        }, 
        open_avail: {
            bef_open_avail: '',
            aft_open_avail: ''
        },
    },
    project_status: {
        status_high_level: {
            implemented: '',
            ongoing_proj_fs: '',
            mature_proj_fs: '',
            proj_under_prep: ''
        }, 
        status_detailed: {
            implemented: '',
            ongoing_proj_fs: {
                workCur: '',
                tenderWork: '',
                designTender: '',
                tenderOngoing: ''
            },
            mature_proj_fs: {
                finOngoing: '',
                finProceduresNotyetStarted: '',
                finSourceNotInd: ''
            },
            proj_under_prep: {
                feasOnGoing: '',
                feasUnderTen: '',
                financing: ''
            }
        }
    },
    project_funding: {
        funding_source: {
            proj_fund_nat_budg: '',
            proj_fund_wb: '',
            proj_fund_ebrd: '',
            proj_fund_eib: '',
            other_ifi: '',
            concessions: '',
            eu_fund: '',
            other_fund: ''
        },
        capex: ""
    },
    performance_indicators: {
        const_period: "",
        capex: "",
        opex: "",
        maint_cost: "",
        interest_during_const: "",
        ebitda: "",
        revenue: "",
        traffic_dev: {
            train_traffic: "",
            pass_traffic: "",
            freight_tn: "",
        }
    }
}

const FREIGHT_LIVE_PM_KPI_INIT = {
    project_type: {
        infrastructure: '',
        reconstruction: '',
        maintenances: '',
        horizontal: ''
    },
    TEN_TCompliance: { 
        inter_modality: {
            bef_inter_modality: '',
            aft_inter_modality: ''
        },
        train_length_740m: {
            bef_train_length_740m: '',
            aft_train_length_740m: ''
        },
        electrification: {
            bef_electrification: '',
            aft_electrification: ''
        }, 
        open_avail: {
            bef_open_avail: '',
            aft_open_avail: ''
        },
    },
    project_status: {
        status_high_level: {
            implemented: '',
            ongoing_proj_fs: '',
            mature_proj_fs: '',
            proj_under_prep: ''
        }, 
        status_detailed: {
            implemented: '',
            ongoing_proj_fs: {
                workCur: '',
                tenderWork: '',
                designTender: '',
                tenderOngoing: ''
            },
            mature_proj_fs: {
                finOngoing: '',
                finProceduresNotyetStarted: '',
                finSourceNotInd: ''
            },
            proj_under_prep: {
                feasOnGoing: '',
                feasUnderTen: '',
                financing: ''
            }
        }
    },
    project_funding: {
        funding_source: {
            proj_fund_nat_budg: '',
            proj_fund_wb: '',
            proj_fund_ebrd: '',
            proj_fund_eib: '',
            other_ifi: '',
            concessions: '',
            eu_fund: '',
            other_fund: ''
        },
        allocated_funding: {
            proj_fund_nat_budg: '',
            proj_fund_wb: '',
            proj_fund_ebrd: '',
            proj_fund_eib: '',
            other_ifi: '',
            concessions: '',
            eu_fund: '',
            other_fund: ''
        }
    },
    project_timeline: {
        tender_start_date: "", // tender_start_date_actual || tender_start_date_curr_est
        design_comp_date: "", // design_comp_date_actual || design_comp_date_curr_est
        proj_comp_date: "", // proj_comp_date_curr_est
    },
    project_tech_status: {
        pre_feasi_study: "",
        feasi_study: "",
        concept_design: "",
        prelim_design: "",
        detail_design: "",
        environ_impact_assess: ""
    },
    social_indicators: {
        si_ann_traff_dem_gro: "",
        si_modal_trans: "",
        si_ann_traff_acci_rate_red: ""
    },
    eco_indicators: {
        ei_eirr: "",
        ei_npv: "",
        ei_sdr: "",
        ei_proj_plan_des_cost: "",
        ei_proj_const_cost: "",
        ei_total_proj_cost: ""
    },
    financial_indicators: {
        fi_firr: "",
        fi_fnpv: "",
        fi_fdr: "",
        fi_wacc: "",
        fi_firts_year_prof: "",
        fi_dscr: ""
    },
    environmental_indicators: {
        eni_co2_ems: "",
        eni_nox_ems: "",
        eni_so2_ems: "",
        eni_nmhc_ems: "",
        eni_ppm: "",
        eni_noise_level: "",
        eni_cli_change_res: "",
        eni_prote_natua_aff: ""
    }
}

const IWW_IMP_PM_KPI_INIT = {
    performanceInd : {
        const_period: "", // actual_const_period / forecast_const_period
        capex: "", // actual_capex/forecast_capex
        opex: "", // actual_opex/forecast_opex
        maint_const: "", // actual_maint_cost/forecast_maint_cost
        interest_during_const: "",
        ebitda: "",
        revenue: "", // actual_revenue/forecast_revenue
        traffic_dev: {
            train_traffic: "", // actual_total/forecast_total CONSULTAR
            pass_traffic: "", // actual_pass_traffic/forecast_pass_traffic
            freight: "" //actual_freight_tn/forecast_freight_tn
        }
    }
}

const IWW_LIVE_PM_KPI_INIT = {
    project_timeline: {
        tender_start_date: "", // tender_start_date_actual || tender_start_date_curr_est
        design_comp_date: "", // design_comp_date_actual || design_comp_date_curr_est
        proj_comp_date: "", // proj_comp_date_curr_est
    },
    project_tech_status: {
        pre_feasi_study: "",
        feasi_study: "",
        concept_design: "",
        prelim_design: "",
        detail_design: "",
        environ_impact_assess: ""
    },
    social_indicators: {
        si_ann_traff_dem_gro: "",
        si_modal_trans: "",
        si_ann_traff_acci_rate_red: ""
    },
    eco_indicators: {
        ei_eirr: "",
        ei_npv: "",
        ei_sdr: "",
        ei_proj_plan_des_cost: "",
        ei_proj_const_cost: "",
        ei_total_proj_cost: ""
    },
    financial_indicators: {
        fi_firr: "",
        fi_fnpv: "",
        fi_fdr: "",
        fi_wacc: "",
        fi_firts_year_prof: "",
        fi_dscr: ""
    },
    environmental_indicators: {
        eni_co2_ems: "",
        eni_nox_ems: "",
        eni_so2_ems: "",
        eni_nmhc_ems: "",
        eni_ppm: "",
        eni_cli_change_res: "",
        eni_prote_natua_aff: ""
    }
}

const IWWP_IMP_PM_KPI_INIT = {
    project_type: {
        infrastructure: "",
        reconstruction: "",
        maintenances: "",
        horizontal: ""
    },
    TEN_TCompliance: {
        rail_conn: {
            bef_rail_conn: "",
            aft_rail_conn: ""
        },
        cmt_conn: {
            bef_cmt_conn: "",
            aft_cmt_conn: ""
        },
        clean_fuels: {
            bef_clean_fuels: "",
            aft_clean_fuels: ""
        },
        terminal_avail: {
            bef_terminal_avail: "",
            aft_terminal_avail: ""
        },
        ris_deploy: {
            bef_ris_deploy: "",
            aft_ris_deploy: ""
        }
    },
    project_status: {
        status_high_level: {
            implemented: "",
            ongoing_proj_fs: "",
            mature_proj_fs: "",
            proj_under_prep: ""
        }, 
        status_detailed: {
            implemented: "",
            ongoing_proj_fs: {
                workCur: "",
                tenderWork: "",
                designTender: "",
                tenderOngoing: "",
            },
            mature_proj_fs: {
                finOngoing: "",
                finProceduresNotyetStarted: "",
                finSourceNotInd: ""
            },
            proj_under_prep: {
                feasOnGoing: "",
                feasUnderTen: "",
                financing: ""
            }
        }
    },
    project_funding: {
        funding_source: {
            proj_fund_nat_budg: "",
            proj_fund_wb: "",
            proj_fund_ebrd: "",
            proj_fund_eib: "",
            other_ifi: "",
            concessions: "",
            eu_fund: "",
            other_fund: ""
        },
        capex: "" // ""
    },
    performance_indicators: {
        const_period: "", // actual_const_period / forecast_const_period
        capex: "", // actual_capex / forecast_capex
        opex: "", // actual_opex / forecast_opex
        maint_cost: "", // actual_maint_cost / forecast_maint_cost
        interest_during_const: "",
        ebitda: "",
        revenue: "", // actual_revenue / forecast_revenue
        traffic_dev: {
            port_traffic: "", // actual_train_traffic/forecast_train_traffic
            pass_traffic: "", // actual_pass_traffic/forecast_pass_traffic
            freight: "" //actual_freight_tn/forecast_freight_tn
        }
    }
}

const IWWP_LIVE_PM_KPI_INIT = {
    project_type: {
        infrastructure: "",
        reconstruction: "",
        maintenances: "",
        horizontal: ""
    },
    TEN_TCompliance: {
        rail_conn: {
            bef_rail_conn: "",
            aft_rail_conn: ""
        },
        cmt_conn: {
            bef_cmt_conn: "",
            aft_cmt_conn: ""
        },
        clean_fuels: {
            bef_clean_fuels: "",
            aft_clean_fuels: ""
        },
        terminal_avail: {
            bef_terminal_avail: "",
            aft_terminal_avail: ""
        },
        ris_deploy: {
            bef_ris_deploy: "",
            aft_ris_deploy: ""
        }
    },
    project_status: {
        status_high_level: {
            implemented: "",
            ongoing_proj_fs: "",
            mature_proj_fs: "",
            proj_under_prep: ""
        }, 
        status_detailed: {
            implemented: "",
            ongoing_proj_fs: {
                workCur: "",
                tenderWork: "",
                designTender: "",
                tenderOngoing: "",
            },
            mature_proj_fs: {
                finOngoing: "",
                finProceduresNotyetStarted: "",
                finSourceNotInd: ""
            },
            proj_under_prep: {
                feasOnGoing: "",
                feasUnderTen: "",
                financing: ""
            }
        }
    },
    project_funding: {
        funding_source: {
            proj_fund_nat_budg: "",
            proj_fund_wb: "",
            proj_fund_ebrd: "",
            proj_fund_eib: "",
            other_ifi: "",
            concessions: "",
            eu_fund: "",
            other_fund: ""
        },
        allocated_funding: {
            proj_fund_nat_budg: "",
            proj_fund_wb: "",
            proj_fund_ebrd: "",
            proj_fund_eib: "",
            other_ifi: "",
            concessions: "",
            eu_fund: "",
            other_fund: ""
        }
    },
    project_timeline: {
        tender_start_date: "", // tender_start_date_curr_est - tender_start_date_init_fore
        design_comp_date: "", // design_comp_date_curr_est - design_comp_date_fore
        proj_comp_date: "" // proj_comp_date_curr_est - proj_comp_date_fore
    },
    project_tech_status: {
        pre_feasi_study: "",
        feasi_study: "",
        concept_design: "",
        prelim_design: "",
        detail_design: "",
        environ_impact_assess: ""
    },
    social_indicators: {
        si_ann_traff_dem_gro: "",
        si_modal_trans: "",
        si_ann_traff_acci_rate_red: ""
    },
    eco_indicators: {
        ei_eirr: "",
        ei_npv: "",
        ei_sdr: "",
        ei_proj_plan_des_cost: "",
        ei_proj_const_cost: "",
        ei_total_proj_cost: ""
    },
    financial_indicators: {
        fi_firr: "",
        fi_fnpv: "",
        fi_fdr: "",
        fi_wacc: "",
        fi_firts_year_prof: "",
        fi_dscr: ""
    },
    environmental_indicators: {
        eni_co2_ems: "",
        eni_nox_ems: "",
        eni_so2_ems: "",
        eni_nmhc_ems: "",
        eni_ppm: "",
        eni_cli_change_res: "",
        eni_prote_natua_aff: ""
    }
}

const SEAPORTS_IMP_PM_KPI_INIT = {
    project_type: {
        infrastructure: "",
        reconstruction: "",
        maintenances: "",
        horizontal: ""
    },
    TEN_TCompliance: {
        rail_conn: {
            bef_rail_conn: "",
            aft_rail_conn: ""
        },
        road_conn: {
            bef_road_conn: "",
            aft_road_conn: ""
        },
        iww_cemt_conn: "",
        clean_fuels: {
            bef_clean_fuels: "",
            aft_clean_fuels: ""
        },
        terminal_avail: {
            bef_terminal_avail: "",
            aft_terminal_avail: ""
        },
        waste_facilities: "",
        vtmis_deploy: ""
    },
    project_status: {
        status_high_level: {
            implemented: "",
            ongoing_proj_fs: "",
            mature_proj_fs: "",
            proj_under_prep: ""
        }, 
        status_detailed: {
            implemented: "",
            ongoing_proj_fs: {
                workCur: "",
                tenderWork: "",
                designTender: "",
                tenderOngoing: "",
            },
            mature_proj_fs: {
                finOngoing: "",
                finProceduresNotyetStarted: "",
                finSourceNotInd: ""
            },
            proj_under_prep: {
                feasOnGoing: "",
                feasUnderTen: "",
                financing: ""
            }
        }
    },
    project_funding: {
        funding_source: {
            proj_fund_nat_budg: "",
            proj_fund_wb: "",
            proj_fund_ebrd: "",
            proj_fund_eib: "",
            other_ifi: "",
            concessions: "",
            eu_fund: "",
            other_fund: ""
        },
        capex: "" // ""
    },
    performance_indicators: {
        const_period: "", // actual_const_period / forecast_const_period
        capex: "", // actual_capex / forecast_capex
        opex: "", // actual_opex / forecast_opex
        maint_cost: "", // actual_maint_cost / forecast_maint_cost
        interest_during_const: "",
        ebitda: "",
        revenue: "", // actual_revenue / forecast_revenue
        traffic_dev: {
            port_traffic: "", // actual_port_traffic/forecast_port_traffic 
            pass_traffic: "", // actual_pass_traffic/forecast_pass_traffic
            freight: "" //actual_freight_tn/forecast_freight_tn
        }
    }
}

const SEAPORTS_LIVE_PM_KPI_INIT = {
    project_type: {
        infrastructure: "",
        reconstruction: "",
        maintenances: "",
        horizontal: ""
    },
    TEN_TCompliance: {
        rail_conn: {
            bef_rail_conn: "",
            aft_rail_conn: ""
        },
        road_conn: {
            bef_road_conn: "",
            aft_road_conn: ""
        },
        iww_cemt_conn: "",
        clean_fuels: {
            bef_clean_fuels: "",
            aft_clean_fuels: ""
        },
        terminal_avail: {
            bef_terminal_avail: "",
            aft_terminal_avail: ""
        },
        waste_facilities: "",
        vtmis_deploy: ""
    },
    project_status: {
        status_high_level: {
            implemented: "",
            ongoing_proj_fs: "",
            mature_proj_fs: "",
            proj_under_prep: ""
        }, 
        status_detailed: {
            implemented: "",
            ongoing_proj_fs: {
                workCur: "",
                tenderWork: "",
                designTender: "",
                tenderOngoing: "",
            },
            mature_proj_fs: {
                finOngoing: "",
                finProceduresNotyetStarted: "",
                finSourceNotInd: ""
            },
            proj_under_prep: {
                feasOnGoing: "",
                feasUnderTen: "",
                financing: ""
            }
        }
    },
    project_funding: {
        funding_source: {
            proj_fund_nat_budg: "",
            proj_fund_wb: "",
            proj_fund_ebrd: "",
            proj_fund_eib: "",
            other_ifi: "",
            concessions: "",
            eu_fund: "",
            other_fund: ""
        },
        allocated_funding: {
            proj_fund_nat_budg: "",
            proj_fund_wb: "",
            proj_fund_ebrd: "",
            proj_fund_eib: "",
            other_ifi: "",
            concessions: "",
            eu_fund: "",
            other_fund: ""
        }
    },
    project_timeline: {
        tender_start_date: "", // tender_start_date_curr_est - tender_start_date_init_fore
        design_comp_date: "", // design_comp_date_curr_est - design_comp_date_fore
        proj_comp_date: "" // proj_comp_date_curr_est - proj_comp_date_fore
    },
    project_tech_status: {
        pre_feasi_study: "",
        feasi_study: "",
        concept_design: "",
        prelim_design: "",
        detail_design: "",
        environ_impact_assess: ""
    },
    social_indicators: {
        si_ann_traff_dem_gro: "",
        si_modal_trans: "",
        si_ann_traff_acci_rate_red: ""
    },
    eco_indicators: {
        ei_eirr: "",
        ei_npv: "",
        ei_sdr: "",
        ei_proj_plan_des_cost: "",
        ei_proj_const_cost: "",
        ei_total_proj_cost: ""
    },
    financial_indicators: {
        fi_firr: "",
        fi_fnpv: "",
        fi_fdr: "",
        fi_wacc: "",
        fi_firts_year_prof: "",
        fi_dscr: ""
    },
    environmental_indicators: {
        eni_co2_ems: "",
        eni_nox_ems: "",
        eni_so2_ems: "",
        eni_nmhc_ems: "",
        eni_ppm: "",
        eni_cli_change_res: "",
        eni_prote_natua_aff: ""
    }
}

const AIRPORTS_IMP_PM_KPI_INIT = {
    project_type: {
        infrastructure: "",
        reconstruction: "",
        maintenances: "",
        horizontal: ""
    },
    TEN_TCompliance: {
        rail_conn: {
            bef_rail_conn: "",
            aft_rail_conn: ""
        },
        clean_fuels: {
            bef_clean_fuels: "",
            aft_clean_fuels: ""
        },
        terminal_avail: {
            bef_terminal_avail: "",
            aft_terminal_avail: ""
        }
    },
    project_status: {
        status_high_level: {
            implemented: "",
            ongoing_proj_fs: "",
            mature_proj_fs: "",
            proj_under_prep: ""
        }, 
        status_detailed: {
            implemented: "",
            ongoing_proj_fs: {
                workCur: "",
                tenderWork: "",
                designTender: "",
                tenderOngoing: "",
            },
            mature_proj_fs: {
                finOngoing: "",
                finProceduresNotyetStarted: "",
                finSourceNotInd: ""
            },
            proj_under_prep: {
                feasOnGoing: "",
                feasUnderTen: "",
                financing: ""
            }
        }
    },
    project_funding: {
        funding_source: {
            proj_fund_nat_budg: "",
            proj_fund_wb: "",
            proj_fund_ebrd: "",
            proj_fund_eib: "",
            other_ifi: "",
            concessions: "",
            eu_fund: "",
            other_fund: ""
        },
        capex: "" // ""
    },
    performance_indicators: {
        const_period: "", // actual_const_period / forecast_const_period
        capex: "", // actual_capex / forecast_capex
        opex: "", // actual_opex / forecast_opex
        maint_cost: "", // actual_maint_cost / forecast_maint_cost
        interest_during_const: "",
        ebitda: "",
        revenue: "", // actual_revenue / forecast_revenue
        traffic_dev: {
            train_traffic: "", // actual_throughput_traffic/forecast_throughput_traffic
            pass_traffic: "", // actual_pass_traffic/forecast_pass_traffic
            freight: "" //actual_freight_tn/forecast_freight_tn
        }
    }
}

const AIRPORTS_LIVE_PM_KPI_INIT = {
    project_type: {
        infrastructure: "",
        reconstruction: "",
        maintenances: "",
        horizontal: ""
    },
    TEN_TCompliance: {
        rail_conn: {
            bef_rail_conn: "",
            aft_rail_conn: ""
        },
        clean_fuels: {
            bef_clean_fuels: "",
            aft_clean_fuels: ""
        },
        terminal_avail: {
            bef_terminal_avail: "",
            aft_terminal_avail: ""
        }
    },
    project_status: {
        status_high_level: {
            implemented: "",
            ongoing_proj_fs: "",
            mature_proj_fs: "",
            proj_under_prep: ""
        }, 
        status_detailed: {
            implemented: "",
            ongoing_proj_fs: {
                workCur: "",
                tenderWork: "",
                designTender: "",
                tenderOngoing: "",
            },
            mature_proj_fs: {
                finOngoing: "",
                finProceduresNotyetStarted: "",
                finSourceNotInd: ""
            },
            proj_under_prep: {
                feasOnGoing: "",
                feasUnderTen: "",
                financing: ""
            }
        }
    },
    project_funding: {
        funding_source: {
            proj_fund_nat_budg: '',
            proj_fund_wb: '',
            proj_fund_ebrd: '',
            proj_fund_eib: '',
            other_ifi: '',
            concessions: '',
            eu_fund: '',
            other_fund: ''
        },
        allocated_funding: {
            proj_fund_nat_budg: '',
            proj_fund_wb: '',
            proj_fund_ebrd: '',
            proj_fund_eib: '',
            other_ifi: '',
            concessions: '',
            eu_fund: '',
            other_fund: ''
        }
    },
    project_timeline: {
        tender_start_date: "",
        design_comp_date: "",
        proj_comp_date: ""
    },
    project_tech_status: {
        pre_feasi_study: "",
        feasi_study: "",
        concept_design: "",
        prelim_design: "",
        detail_design: "",
        environ_impact_assess: ""
    },
    social_indicators: {
        si_ann_traff_dem_gro: "",
        si_modal_trans: "",
        si_ann_traff_acci_rate_red: ""
    },
    eco_indicators: {
        ei_eirr: "",
        ei_npv: "",
        ei_sdr: "",
        ei_proj_plan_des_cost: "",
        ei_proj_const_cost: "",
        ei_total_proj_cost: ""
    },
    financial_indicators: {
        fi_firr: "",
        fi_fnpv: "",
        fi_fdr: "",
        fi_wacc: "",
        fi_firts_year_prof: "",
        fi_dscr: ""
    },
    environmental_indicators: {
        eni_co2_ems: "",
        eni_nox_ems: "",
        eni_so2_ems: "",
        eni_nmhc_ems: "",
        eni_ppm: "",
        eni_cli_change_res: "",
        eni_prote_natua_aff: ""
    }
}

export { ROADS_NPM_KPI_INIT, ROADS_SAFETY_KPI_INIT, RAILWAYS_NPM_KPI_INIT, FREIGHT_TERMINAL_NPM_KPI_INIT, IWW_NPM_KPI_INIT, IWW_PORTS_NPM_KPI_INIT, SEAPORTS_NPM_KPI_INIT, 
    AIRPORTS_NPM_KPI_INIT, BORDER_CROSSING_NPM_KPI_INIT, ROAD_IMP_PM_KPI_INIT, ROAD_LIVE_PM_KPI_INIT, RAILWAYS_IMP_PM_KPI_INIT, RAILWAYS_LIVE_PM_KPI_INIT, FREIGHT_TERMINAL_IMP_PM_KPI_INIT,
    FREIGHT_LIVE_PM_KPI_INIT, IWW_IMP_PM_KPI_INIT, IWW_LIVE_PM_KPI_INIT, IWWP_IMP_PM_KPI_INIT, IWWP_LIVE_PM_KPI_INIT, SEAPORTS_IMP_PM_KPI_INIT, SEAPORTS_LIVE_PM_KPI_INIT,
    AIRPORTS_IMP_PM_KPI_INIT, AIRPORTS_LIVE_PM_KPI_INIT };